// ─── Navigation Tab Labels ─────────────────────────────────────────────────────

export const HR_TAB_LABELS = {
  JOBS_LIBRARY: "Jobs Library",
  SKILLS_BRIDGER: "Skills Bridger",
  LEARNING_CATALYST: "Learning Catalyst",
  TALENT_MOBILITY: "Talent Mobility",
};
